import { createFileRoute } from '@tanstack/react-router';

import { VoicePage } from '~/features/account/voice-page';

export const Route = createFileRoute('/_app/account/voice')({
  component: VoicePage,
});
